export const HIGHLIGHTS = [
  {
    imageUrl: '/images/highlights/FM_Awards2024-01-min.jpg',
    previewImageUrl: '/images/highlights/FM_Awards2024-01-min.jpg',
    videoUrl: null
  },
  {
    imageUrl: '/images/highlights/FM_Awards2024-02-min.jpg',
    previewImageUrl: '/images/highlights/FM_Awards2024-02-min.jpg',
    videoUrl: null
  }
]
